/* tslint:disable */
import {Injectable, Injector} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {TwoDService} from "./views/two-dview/two-d.service";
import {UserService} from "./user-management/user.service";
import {float} from "aws-sdk/clients/lightsail";
import {Sharing3DViewData} from './sharing-3d-view-data.model';
import {WebGLService} from "./views/three-dview/web-gl.service";
import canvasScreenshot from "canvas-screenshot";
import {environment} from "../../environments/environment";
import {HttpService} from "../http.service";
import {RegionsService} from "./regions/regions.service";
import {RecordVideosService} from "./record-videos.service";
import {UserData} from './models'

@Injectable({
    providedIn: 'root'
})

export class AtlasSharedService {
    urlLoadNewestRegionVersionData = environment.apiURL + 'load_newest_region_version_data';

    panelMovementOptions: PanelMovementOptions = new PanelMovementOptions();

    userData: UserData = new UserData();

    shareViewProgress: ShareViewProgress = new ShareViewProgress();

    sharingCurrentViewStatus: SharingCurrentViewStatus = new SharingCurrentViewStatus();

    // This object will be initialized when the user opens the sharing view LINK and will be globally accessible across all controllers.
    sharedViewItems: SharedViewItems = new SharedViewItems();

    /* This object stores all the values associated with the 3D view, such as rotations, scene settings, clipping information, and the selected brain model.
    Once the user clicks on the 'Share Current View' button, the object will be sent to the backend.*/
    sharing3DViewData: Sharing3DViewData = new Sharing3DViewData();


    // The Resolution Options in the 3D view
    screenshotResolutionOptions = [
        {name: 'Standard', scaleFactor: 2},
        {name: 'Medium', scaleFactor: 3},
        {name: 'High', scaleFactor: 4},
        // {name: 'Best', scaleFactor: 5}
    ]

    // Herwig requested to display the count of neurons, regions, and markers beside each panel on the left side menu.
    itemsCount = {
        markers: 0,
        regions: 0,
        neurons: 0
    };

    // Initialize the screenshot state
    screenshotState: ScreenshotState = {
        isWaitingForScreenshot: false,  // Indicates if the system is waiting for a screenshot // --Added specifically for capturing Herwig regions in the video recording process
        isFromSafari: false
    };

    defaultRegionVersion = "2.0 (MECE, 2024)"


    constructor(private spinner: NgxSpinnerService,
                private injector: Injector,
                public userService: UserService,
                private httpService: HttpService,
                private recordVideosService: RecordVideosService) {
        this.userService.listenToUserStatus();
        this.userService.subjectUserData.subscribe((userDataResponse) => {
            if (userDataResponse) {
                this.userData.id = userDataResponse['id'];
                this.userData.username = userDataResponse['username'];
                this.userData.saved_data = userDataResponse['saved_data'];
            } else {
                // Reset user data if userDataResponse is null (e.g., on logout)
                this.userData = new UserData();
            }
        });
        this.checkIfSafari();

        this.loadNewestRegionVersionData();

    }

    loadNewestRegionVersionData() {
        this.httpService.postRequest(this.urlLoadNewestRegionVersionData, {})
            .subscribe(response => {
                    if (response.success) {
                        this.defaultRegionVersion = response.versionData.display_name

                        let regionsService = this.injector.get<RegionsService>(RegionsService);
                        regionsService.regionsData.selectedRegionVersion = response.versionData;
                    }
                },
                error => {
                    console.error(error);
                })

    }

    updateScene(time) {
        let twoDService = this.injector.get<TwoDService>(TwoDService);
        setTimeout(() => {
            twoDService.updateScene().then(r => this.spinner.hide());
        }, time)
    }


    convertDictionaryToArray(options, array) {
        for (const [key, value] of Object.entries(options)) {
            array.push(value);
        }
    }

    onHidePanelMovementOptions(isOpen = false, isTwoDVisualizationOptions = false, isThreeDVisualizationOptions = false, isMarkersFiltersOptions = false, isGetRegionsOfPosition = false) {
        this.panelMovementOptions.isOpen = isOpen;
        this.panelMovementOptions.isTwoDVisualizationOptions = isTwoDVisualizationOptions;
        this.panelMovementOptions.isThreeDVisualizationOptions = isThreeDVisualizationOptions;
        this.panelMovementOptions.isMarkersFilters = isMarkersFiltersOptions;
        this.panelMovementOptions.isGetRegionsOfPosition = isGetRegionsOfPosition;

        if (this.panelMovementOptions.isTwoDVisualizationOptions) {
            this.panelMovementOptions.label = "2D visualization options";
        } else if (this.panelMovementOptions.isThreeDVisualizationOptions) {
            this.panelMovementOptions.label = "3D visualization options";
        } else if (this.panelMovementOptions.isMarkersFilters) {
            this.panelMovementOptions.label = "Markers filters";
        } else if (this.panelMovementOptions.isGetRegionsOfPosition) {
            this.panelMovementOptions.label = "Regions of the selected position";
        }
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    scrollToNeuronElement(id): void {
        // $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
        //this.scroller.scrollToAnchor("targetGreen");
        document.getElementById(id).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }

    resetAndRenderOriginalDimensions(webGLService: WebGLService): void {
        const widthInput = webGLService.webGLVariables.viewPort.size.width;
        const heightInput = webGLService.webGLVariables.viewPort.size.height;

        // Update camera and renderer dimensions
        webGLService.webGLVariables.cameraVariables.camera.aspect = widthInput / heightInput;
        webGLService.webGLVariables.cameraVariables.camera.fov = 75;
        webGLService.webGLVariables.cameraVariables.camera.updateProjectionMatrix();
        webGLService.webGLVariables.renderer.setSize(widthInput, heightInput);

        // Render the scene
        webGLService.webGLVariables.renderer.render(
            webGLService.webGLVariables.scene,
            webGLService.webGLVariables.cameraVariables.camera,
            null,
            false
        );
    }


    async take3DScreenshot(scaleFactor: number, spinner = true): Promise<void> {
        this.screenshotState.isWaitingForScreenshot = true;

        if (spinner) {
            this.spinner.show();
        }
        this.delay(800).then();

        const webGLService = this.injector.get<WebGLService>(WebGLService);

        const widthInput = window.innerWidth * scaleFactor;
        const heightInput = window.innerHeight * scaleFactor;

        if (this.screenshotState.isFromSafari) {
            webGLService.webGLVariables.renderer.setSize(widthInput, heightInput);
        } else {
            // Calculate the division factor based on how many times innerWidth increased by 1000 pixels
            const divisionFactor = Math.floor(window.innerWidth / 900) + 1;
            webGLService.webGLVariables.renderer.setSize(widthInput / divisionFactor, heightInput / divisionFactor);
        }

        const camera = webGLService.webGLVariables.cameraVariables.camera;
        // Calculate aspect ratio based on canvas dimensions
        const aspectRatio = widthInput / heightInput;
        // Set the camera's aspect ratio
        camera.aspect = aspectRatio;
        // Adjust Field of View (FOV) (in degrees). A larger FOV captures more of the scene, while a smaller FOV captures a narrower, zoomed-in view.
        // The initial FOV value is set to 75.
        camera.fov = 85;
        // Update the camera's projection matrix
        camera.updateProjectionMatrix();

        webGLService.webGLVariables.renderer.render(
            webGLService.webGLVariables.scene,
            webGLService.webGLVariables.cameraVariables.camera,
            null,
            false
        );

        // Capture the screenshot
        canvasScreenshot(webGLService.webGLVariables.renderer.domElement);

        // Reset to the original dimensions and hide the spinner
        this.resetAndRenderOriginalDimensions(webGLService);


        this.spinner.hide();

        //-----------------------Added specifically for capturing Herwig regions in the video recording process---------------------
        // setTimeout(() => this.recordVideosService.handleHerwigRegionDraw(this.screenshotState), 1000);
    }


    checkIfSafari() {
        const userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
            this.screenshotState.isFromSafari = true;
        }
    }


}


class PanelMovementOptions {
    isOpen: boolean = false;
    isTwoDVisualizationOptions: boolean = false;
    isThreeDVisualizationOptions: boolean = false;
    isAdvancedSearch: boolean = false;
    isMarkersFilters: boolean = false;
    isGetRegionsOfPosition: boolean = false;
    allowVisualizationOptionsPanelDragging: boolean = true;
    label: string = '';
}

class ShareViewProgress {
    toSend: float = 0;
    toRetrieve: number = 0;
}

class SharingCurrentViewStatus {
    hash: string = '';
    btnClicked: boolean = false;
}

class SharedViewItems {
    isLoading: boolean = false; //Indicates whether the data has been loaded from the database when navigating through a shareable link.
    markers: MarkersStatus = new MarkersStatus();
    regions: RegionsStatus = new RegionsStatus();
    neurons: NeuronsStatus = new NeuronsStatus();
}

class MarkersStatus {
    ids: number[] = [];
    enhancement: any[] = [];
    fishDictionary: any = {};
}

class RegionsStatus {
    opacity: any[] = [];
    onlyOutline: any[] = [];
}

class NeuronsStatus {
    hasSelectedNeurons: boolean = false;
    isLoaded: boolean = false;
}

export class ScreenshotState {
    isWaitingForScreenshot: boolean;
    isFromSafari: boolean;
}

